<template>
  <div class="active-schools">
    <h1 class="text-center my-7">تستر ها</h1>
    <v-row>
      <v-col cols="12" md="3" class="px-2">
        <NavigationComponent />
      </v-col>
      <v-col cols="12" md="9" class="px-2 py-0">
        <v-row>
          <v-col cols="12" :md="user ? '6' : '12'">
            <v-card class="elevation-0 mb-5 pa-5">
              <h5>اضافه کردن تستر جدید</h5>
              <v-form
                v-model="valid"
                @submit.prevent="findUser"
                class="text-center"
              >
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="mobile"
                      :rules="mobileRules"
                      autocomplete="off"
                      label="شماره همراه کاربر"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      :loading="loading"
                      :disabled="!valid || loading"
                      depressed
                      block
                      color="primary"
                      type="submit"
                    >
                      جستجو
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-col>
          <v-col v-if="user" cols="12" md="6">
            <v-card class="elevation-0 mb-5 pa-5">
              <v-list-item>
                <v-list-item-content class="text-center">
                  <div class="mb-4">
                    {{ user.username }}
                  </div>
                  <v-list-item-title class="headline mb-4">
                    {{ user.firstname + " " + user.lastname }}
                  </v-list-item-title>
                  <v-list-item-title>
                    نوع کاربر: {{ user.type }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-card-actions>
                <v-btn
                  :disabled="user.type == 'تستر'"
                  block
                  rounded
                  depressed
                  color="success"
                  @click="setTester(user._id)"
                >
                  {{
                    user.type == "تستر"
                      ? "کاربر در حال حاضر تستر است"
                      : "تبدیل کاربر به تستر"
                  }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <h3 class="mb-5">لیست تستر ها</h3>
        <v-data-table :headers="headers" :items="testers" :items-per-page="10">
          <template v-slot:[`item._id`]="{ item }">
            <div class="d-flex justify-center">
              <v-btn
                depressed
                small
                color="error"
                class="mr-2"
                @click="disableTester(item._id)"
              >
                غیر فعال کردن حالت تست
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.requestDate`]="{ item }">
            <persian-date :date="item.requestDate" />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NavigationComponent from "./_Navigation.vue";
export default {
  name: "agents-component",
  components: {
    NavigationComponent
  },
  data: () => {
    return {
      valid: true,
      loading: false,
      mobile: null,
      mobileRules: [
        (v) => !!v || "لطفا تلفن همراه خود را وارد نمایید",
        (v) => (v && v.length == 11) || "تلفن همراه را به درستی وارد نمایید"
      ],
      user: null,
      testers: [],
      headers: [
        { text: "نام", value: "firstname", align: "center" },
        { text: "نام خانوادگی", value: "lastname", align: "center" },
        { text: "شماره همراه", value: "username", align: "center" },
        { text: "عملیات", value: "_id", align: "center" }
      ]
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$api.get("/user/testers").then((res) => {
        this.testers = res.data.users;
      });
    },
    findUser() {
      this.$api
        .post("/user/getbymobile", {
          mobile: this.mobile
        })
        .then((res) => {
          this.user = res.data.user;
        });
    },
    setTester(id) {
      this.$api
        .post("/user/setTester", {
          user: id
        })
        .then(() => {
          this.getData();
          this.user = null;
        });
    },
    disableTester(id) {
      this.$api
        .post("/user/setDefault", {
          user: id
        })
        .then(() => {
          this.getData();
        });
    }
  }
};
</script>
